<template>
      <div class="vsebina ">

    <div class="glava_vsebine adapt v-adapt">

      <div class="cols">
      <div class="col left grid-col-6">
        <h1>Dodaj predelovalca</h1>
      </div>
      
      
      
      <div class="col right">
      </div>
      
      </div>
    </div>
    
    <div class="telo_vsebine adapt v-adapt">

<div>
        <div :style="{ display: 'inline-block' }">
            Sezona
            <br />
            <dropdownlist
                :data-items="sezonePisanje"
                :text-field="'sezona'"
                @change="sezonaChange"
                :value="dataSezona"
            />
          </div>
        </div>

<div class="">
<form @submit.prevent="handleSubmit" class="k-form">
            <div class="form-group">
                  <div class="km-widget km-buttongroup k-widget k-button-group">
                <button  type="button" class="k-button k-primary" @click="saveData" :disabled="!saveEnabled" >Shrani</button>
                <button type="button" class="k-button k-primary" @click="nazajPredelava" >Nazaj</button>
               </div>
             </div>

    <div class="display-flex pt-1">
    <div>
            <fieldset class="left-border-for-children">
                 <div class="form-fieldset-header">
            <h2 >Predelovalec</h2>
        </div>
          <label for="mso" class="k-form-field">
                <span>Mšo</span>
                  <div class="display-flex">
                <input type="text" v-model="mso"   @change="dataChange" placeholder="MŠO" name="mso" class="k-textbox" v-on:keyup.enter="loadDataMso"/>
                  <span class="input-icon-search"  @click="loadDataMso"><font-awesome-icon icon="search"/></span>
                    </div>  
            </label>
             <label for="ds" class="k-form-field">
                <span>Davčna številka</span>
                  <div class="display-flex">
                <input type="text" v-model="ds"  @change="dataChange" placeholder="Davčna številka" name="ds" class="k-textbox" v-on:keyup.enter="loadDataDs"/>
                  <span class="input-icon-search"  @click="loadDataDs"><font-awesome-icon icon="search"/></span>
                    </div>  
            </label>
            <label for="naziv" class="k-form-field">
                <span>Naziv</span>
                <input type="text" disabled v-model="predelovalec.naziv" placeholder="Naziv" @change="dataChange" name="naziv" id="naziv" class="k-textbox"/>
               </label>
            <label for="naslov" class="k-form-field">
                <span>Naslov</span>
                <input type="text" disabled v-model="predelovalec.naslov" placeholder="Naslov" name="naslov" id="naslov" class="k-textbox" />
            </label>
            <div class="k-form-field display-flex">
            <label for="postnastevilka">
                <span>Poštna številka</span>
                <input type="text" v-model="predelovalec.postnastevilka"  disabled placeholder="Poštna številka" name="postnastevilka" id="postnastevilka" class="k-textbox" />
            </label>
            <label for="posta" class="flex-grow-1" >
                <span>Pošta</span>
                <input type="text" v-model="predelovalec.posta" placeholder="Pošta" disabled name="posta" id="posta" class="k-textbox" />
            </label>
        </div>
          <label for="kontrolnastevilka" class="k-form-field">
                <span>Kontrolna številka</span>
                
                <input type="text" v-model="kontrolnastevilka" placeholder="Kontrolna številka"  @change="kntChange" requried name="kontrolnastevilka" id="kontrolnastevilka" class="k-textbox" />
                 
            </label>

            </fieldset>
             </div>
             
               
           </div>
        </form>
    </div>
    </div>
    </div>

</template>

<script>
import { mapState, mapActions,mapMutations } from 'vuex'
import { DatePicker } from '@progress/kendo-dateinputs-vue-wrapper';
import { NumericTextBox } from '@progress/kendo-inputs-vue-wrapper';
import { MultiSelect } from '@progress/kendo-dropdowns-vue-wrapper';
import { DropDownList } from '@progress/kendo-vue-dropdowns';
export default {
     components: {
    'kendo-datepicker': DatePicker,
    'kendo-multiselect': MultiSelect,
    'dropdownlist': DropDownList,
    'kendo-numerictextbox': NumericTextBox,
  },
    props:['sezona'],
    data () {
        return {
             dataSezona:this.sezona,
             sezone:[],
             dataValid:false,
            multiselectValue:[],posta:"",postnastevilka:"",naslov:"",ime:"",priimek:"",telefon:"",email:"",opomba:"",postnastevilkakontakt:"",postakontakt:"",postnastevilkanosilec:"",postnanosilec:"",naslovkontakt:"",priimekkontakt:"",postanosilca:"",postnastevilkanosilca:"",kontrolnastevilka:"",
            emailnosilca:"",telefonnosilca:"",
            statusDolocen: new Date(),
            izbranStatus: {"value":0,"text":"Nedoločen"},
            password: '',
            submitted: false,
            multiselectmessages: 
            {
            "singleTag": "izbrani elementi",
            "clear": "Počisti",
            "deleteTag": "Izbriši",
            "noData": "Ni podatkov"
            },
            vrsta:[],
            status:[],
        }
    },
    computed: {
        ...mapState('predelava', ['predelovalec']),
        //sezone v katerih lahko piše!
        ...mapState('users', ['sezonePisanje']),
        ...mapState('sifrant', ['sifrant']),
        ...mapState('alert', ['type']),
        saveEnabled(){

          return (this.dataValid)&&(this.type!='k-notification-error');
        },
       
        ds:{
          get() {
            return this.predelovalec.ds;
          },
          set(value) {
            this.updateds(value);
          }
        },
        mso:{
          get() {
            return this.predelovalec.mso;
          },
          set(value) {
            this.updatemso(value);
          }
        }
        
    },
    created () {
       this.naloziPodatke();
       this.clear();
     
    },
    methods: {
        
        ...mapActions({naloziSifrant: 'sifrant/load'}),
          ...mapActions({clearAlert: 'alert/clear'}),
        ...mapActions('predelava',['loadbyds','loadbymso','clear','saveobrat']),
        ...mapMutations('predelava',['updateds','updatemso']),
        handleSubmit(e){

          e.preventDefault();
        },
        cancel(e){

          //kontrolna je prazna, preveri...

          //kliči save, izpiši error msg
          // v api poglej, če že ta ko ima mid, če ga ima, ga ne dodaj, javi mu aktivnost, mogoče daj link...
          //če že ima kera druga ko sedaj, ali ga je imela v preteklosti, javi 

          //potem idi naredit urejanje...
            this.$router.go(-1)
        },
        saveData(e){

         
          //kontrolna je prazna, preveri...

          //kliči save, izpiši error msg
          // v api poglej, če že ta ko ima mid, če ga ima, ga ne dodaj, javi mu aktivnost, mogoče daj link...
          //če že ima kera druga ko sedaj, ali ga je imela v preteklosti, javi 



            this.saveobrat({kontrolnastevilka:this.kontrolnastevilka,...this.dataSezona}).then(
              data=>{
                console.log(data);
               this.dataValid=false;
              },
              error=>{

              console.log(error);
              }
              )
          //potem idi naredit urejanje...
            
        },
           kntChange(e){
            this.clearAlert();
        },
          dataChange(e){
            this.dataValid=false;
        },
        loadDataMso (e) {

          this.loadbymso(this.predelovalec);
          this.dataValid=true;


          
        },
        loadDataDs (e) {
              this.dataValid=true;
             this.loadbyds(this.predelovalec);
             

          
        },
        naloziPodatke (){
             this.dataSezona={sezona:this.sezona};
       // this.dataSezone
//         this.sifrant["statuspredelovalca"]
  //       this.sifrant["vrstapredelovalca"]
      
        },
         sezonaChange(event) {
            const sezona = event.value;
            this.dataSezona=sezona;
           // this.naloziPodatke();



        },
    }
};
</script>

<style>
form {
display:flex;
flex-direction:column;
}


</style>